import * as log from 'loglevel';
import {find, sample, times, pullAt, random, shuffle} from "lodash"
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {hideSecondaryScreens, showPrimaryScreen, showSecondaryScreen} from "../../ScreenManager";
import {getGameManager} from "../../../game/GameManager";
import {Observable} from '~knockout/index';
import {ObservableArray} from '~knockout/index';
import {questionData} from '../../../data/Questions';
import {startUsingNewTileset} from "../../../game/level/backgrounds/Backgrounds";
import {gameState} from "../../../game/config/GameState";
import {queuePowerUp} from "../../../game/level/power-ups/PowerUps";
import {startStage} from '../../../game/level/stages/StageManager';
import {gameConfig} from '../../../game/config/GameConfig';
import {resetObstacles} from '../../../game/level/ground/Obstacles';
import {hideSign} from '../../../game/sprites/player/Player';
import {allowPlatforms} from '../../../game/level/platforms/Platforms';
import {playSound} from '../../../game/audio/AudioManager';

interface IQuestion
{
    question: string;
    options: IAnswer[];
    response: string;
}
interface IAnswer
{
    label: string;
    response: string;
    correct?: boolean;
}

var template = require('./QuestionOverlayComponent.html');


class GameplayQuestionOverlayComponent extends Screen
{
    state: Observable<string>;
    question: IQuestion;
    questionText: Observable<string>;
    answers: ObservableArray<IAnswer>;
    responseLabel: Observable<string>;
    responseText: Observable<string>;

    unaskedQuestions: number[];

    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getSecondaryScreenVisibilityOptions('gameplay', 'question');
    }


    /**
     * create knockout bindings
     */
    createBindings()
    {
        super.createBindings();

        this.state = ko.observable();
        this.questionText = ko.observable();
        this.answers = ko.observableArray();
        this.responseLabel = ko.observable();
        this.responseText = ko.observable();
    }


    /**
     * when we show the game screen, start the game
     */
    onShow()
    {
        //  set the overlay state

        this.state('question');

        var timeline: TimelineMax;

        timeline = new TimelineMax();

        timeline.fromTo('.pp-gameplay-question', 0.5, { opacity: 0 }, { opacity: 1, ease: Expo.easeOut });
        timeline.fromTo('.pp-gameplay-question__modal--question', 1, { top: '-300%' }, { top: '50%', ease: Back.easeOut, easeParams: [0.8] }, 0.5);

        //  get the question to ask

        this.question = this.getQuestion();

        //  show the question

        this.askQuestion(this.question);

    }


    /**
     * get a question object from the data
     */
    getQuestion() : IQuestion
    {
        var questionIndex: number;

        //  if no array of unasked questions exists, create one now

        if ( ! this.unaskedQuestions || this.unaskedQuestions.length === 0)
        {
            this.unaskedQuestions = times(questionData.length, (i: number) =>
            {
                return i;
            });

            this.unaskedQuestions = shuffle(this.unaskedQuestions);
        }

        //  pull and random index from the array of unasked questions

        questionIndex = this.unaskedQuestions.shift();

        //  use that question

        return <IQuestion>questionData[questionIndex];
    }


    /**
     * show the overlay and pose a question
     */
    askQuestion(questionObj: IQuestion)
    {
        this.questionText(questionObj.question);
        this.answers(questionObj.options);
    }


    /**
     * when the user selects and answer
     */
    selectAnswer = (answer: IAnswer) =>
    {
        log.debug('chosen answer', answer);

        //  choose the correct answer

        var correctAnswer: IAnswer = <IAnswer>find(this.question.options, 'correct');

        //  set the answer title and response

        this.responseLabel(correctAnswer.label);
        this.responseText(this.question.response);

        //  check whether the chosen answer is correct

        answer.correct === true ? this.answerIsCorrect() : this.answerIsIncorrect();
    };


    /**
     * the answer is correct! huzzah!
     */
    answerIsCorrect()
    {
        //  set the overlay state

        this.state('correct');

        //  if the answer is correct, award the user some bonus time

        getGameManager().incrementTimeRemaining(gameConfig.game.questionBonusTime);

        //  display power-up effect to the user

        getGameManager().visibleBonus('+' + gameConfig.game.questionBonusTime + ' seconds');

        //  play sound

        playSound('correct-answer');
    }


    /**
     * incorrect answer: BOO.
     */
    answerIsIncorrect()
    {
        //  set the overlay state

        this.state('incorrect');

        //  play sound

        playSound('incorrect-answer');
    }


    /**
     * continue with the game
     */
    continueGame()
    {
        var timeline: TimelineMax;

        timeline = new TimelineMax({ onComplete: () =>
        {
            //  close the question overlay

            showSecondaryScreen(null);
        }});

        timeline.to('.pp-gameplay-question__modal--question', 1, { top: '-20%', ease: Back.easeOut, easeParams: [0.8] });
        timeline.to('.pp-gameplay-question', 0.5, { opacity: 0, ease: Expo.easeOut }, 0.25);


        //  start counting the score again

        //  we're not longer outside

        gameState.level.isOutside = false;

        //  queue the next tileset

        startUsingNewTileset();

        //  resume creating platforms and power-ups

        // generatePlatform();

        setTimeout(() => hideSign(), 500);
        setTimeout(() =>
        {
            showSecondaryScreen('level-intro');
        }, 1000);

        setTimeout(() =>
        {
            //  start counting down the timer again

            startStage();

        }, 4000);

        //  play a button sound

        playSound('button-click');

        //  restore control

        gameState.player.isControllable = true;
    }
}


/**
 * register this component with knockout
 * @param vizID
 */
export function registerGameplayQuestionOverlayComponent()
{
    ko.components.register('pp-gameplay-question-overlay',
        {
            viewModel: () => { return new GameplayQuestionOverlayComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/questions/QuestionOverlayComponent.ts